// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__29_AA","large":"styles_large__3FIBo"};